import { Header } from "./Header.";
import Footer from "./Footer";
import React from "react";
import PageHeader from "./PageHeader";
import './Styles/about.css'
import About1 from '../Images/about.png'
import Reconditionned from '../Images/about4.jpg'
import Targets from '../Images/about2.jpg'
import Payment from '../Images/about3.jpg'
import Advantages from '../Images/about1.jpg'
import Deliver from '../Images/about5.jpg'
import Back from '../Images/about6.jpg'

export const About = () => {

    document.title = "A Propos - KabaaShop";

    return (
        <>
            <Header />
            <PageHeader title={"A Propos"} />
            <div className="about-container">
                <h2 className="about-title"><span>01.</span>Qui Sommes-Nous ?</h2>

                <p>
                    KabaaShop est une plateforme d’E-commerce
                    spécialisée dans la vente en gros et/ou en
                    détail d’articles électroniques, cosmétiques et
                    textiles. Elle évolue aussi dans le marketing et
                    la communication pour les entreprises voulant
                    avoir une visibilité sur le marché. Avec de grandes marques et des distributeurs
                    agréés tels que Samsung, Apple, Itel, Iphone,
                    Nasco, Pilotcheli, Ndosy, etc sur toutes ses
                    plates-formes sociales confondues elle offre
                    de quoi faire le bonheur de ceux qui désirent
                    une bonne visibilité pour leur business et
                    autres.
                </p>
                <h2 className="about-title"><span>02.</span>Pourquoi le <span>Sénégal</span> ?</h2>
                <p>
                    Véritable carrefour de l’Afrique de l’Ouest avec une ouverture sur le monde
                    et une stabilité politique, La Téranga correspond à l’hospitalité accordée aux
                    étrangers et à l’accueil chaleureux qui leur est réservée afin que leur séjour au
                    Sénégal soit une réussite. De plus, Il est plus facile d'effectuer les formalités de séjour aussi bien pour les touristes que pour
                    les investisseurs étrangers. Aujourd’hui il est bien possible de développer un
                    projet de E-commerce au Sénégal car ce mode de vie est déjà ancré dans la
                    mentalité de la population.
                </p>

                <div className="about-cards">
                    <div className="about-cards_item">
                        <div className="about-card">
                            <div className="about_card_image">
                                <img src={Reconditionned} alt="reconditionned"/>
                            </div>
                            <div className="about-card_content">
                                <h2 className="about-card_title">Appareils Reconditionnés</h2>
                                <div className="about-card_text">
                                    <p>
                                        Le client cherche un produit moins cher, garanti et
                                        fonctionnel à 100%, une seule adresse KabaaShop.
                                        Kabaashop propose des produits reconditionnés, c’est à
                                        dire des articles ayant déjà servi mais remis en état et
                                        testés par des professionnels.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="about-cards_item">
                        <div className="about-card">
                            <div className="about_card_image">
                                <img src={Targets} alt="our-targets"/>
                            </div>
                            <div className="about-card_content">
                                <h2 className="about-card_title">Nos Cibles</h2>
                                <div className="about-card_text">
                                    <p>
                                        Chez KABAASHOP, nous nous intéressons à tout
                                        le monde (le touriste, le curieux, le maniaque et
                                        l’expert) nous proposons les meilleurs produits à
                                        temps et nous livrons au bon endroit (acheter n’a
                                        jamais été aussi simple et sécurisé....)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="about-cards_item">
                        <div className="about-card">
                            <div className="about_card_image">
                                <img src={Payment} />
                            </div>
                            <div className="about-card_content">
                                <h2 className="about-card_title">Moyens de paiement</h2>
                                <div className="about-card_text">
                                    <p>
                                        KabaaShop propose à ses clients différents moyens de paiement mobile qui pourront faciliter et rendre plus
                                        rapide les transactions sur la plateforme. Entre autres
                                        nous avons Orange Money , Wave , Free Money et
                                        Visa, Mastercard
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="about-cards_item">
                        <div className="about-card">
                            <div className="about_card_image">
                                <img src={Advantages} alt="our-avantages"/>
                            </div>
                            <div className="about-card_content">
                                <h2 className="about-card_title">Nos Avantages</h2>
                                <div className="about-card_text">
                                    <p>
                                        Produits garantis et de référence
                                        <ul style={{ marginLeft: '25px' }}>
                                            <li>Fiabillité</li>
                                            <li>Rapidité</li>
                                            <li>Simplicité</li>
                                            <li>Satisfait ou remboursé</li>
                                        </ul>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="about-cards_item">
                        <div className="about-card">
                            <div className="about_card_image">
                                <img src={Deliver} alt="delivery"/>
                            </div>
                            <div className="about-card_content">
                                <h2 className="about-card_title">Modes de livraison</h2>
                                <div className="about-card_text">
                                    <p>
                                        <ul style={{ marginLeft: '25px' }}>
                                            <li>Livraison à domicile par nos services</li>
                                            <li>Livraison dans des points relais</li>
                                            <li>Livraison dans nos locaux</li>
                                        </ul>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="about-cards_item">
                        <div className="about-card">
                            <div className="about_card_image">
                                <img src={Back} alt="product-back"/>
                            </div>
                            <div className="about-card_content">
                                <h2 className="about-card_title">Retour de produit</h2>
                                <div className="about-card_text">
                                    <p>
                                        Toute marchandise qui présente des problèmes
                                        pourra être retournée sous un délai de 48
                                        heures. <a style={{color: '#C8437E'}} href="/cgv">Voir nos conditions</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <Footer />
        </>
    );
};
